module.exports = __webpack_public_path__ + "img/jet-fighter.4fcd1516.svg";